import { GpmData } from "../types/types";

export type FixtureUnitField = {
	id: string;
	label: string;
	multiplier: number;
};

export const SEWAGE_FIXTURE_UNITS: FixtureUnitField[] = [
	{ id: "trap_1_25", label: '1.25" Trap', multiplier: 2 },
	{ id: "trap_1_5", label: '1.5" Trap', multiplier: 3 },
	{ id: "trap_2", label: '2" Trap', multiplier: 4 },
	{ id: "trap_2_5", label: '2.5" Trap', multiplier: 5 },
	{ id: "trap_3", label: '3" Trap', multiplier: 6 },
	{ id: "trap_4", label: '4" Trap', multiplier: 8 },
	{ id: "bathtub_1_5", label: 'Bathtub 1.5" Trap', multiplier: 2 },
	{ id: "bathtub_2", label: 'Bathtub 2" Trap', multiplier: 3 },
	{ id: "bidet_1_5", label: 'Bidet 1.5" Trap', multiplier: 3 },
	{ id: "br_group_flush_tank", label: "BR Group (flush tank)", multiplier: 6 },
	{ id: "br_group_flush_valve", label: "BR Group (flush valve)", multiplier: 6 },
	{ id: "dental_unit", label: "Dental Unit", multiplier: 1 },
	{ id: "dishwasher", label: "Dishwasher", multiplier: 2 },
	{ id: "drinking_fountain", label: "Drinking Fountain", multiplier: 1 },
	{ id: "kit_sink_disposal", label: "Kit Sink w/Disposal", multiplier: 3 },
	{ id: "kitchen_sink", label: "Kitchen Sink", multiplier: 2 },
	{ id: "laundry_tray", label: "Laundry Tray", multiplier: 2 },
	{ id: "lav_barber_beauty", label: "Lav. Barber / Beauty", multiplier: 2 },
	{ id: "lavatory_1_5", label: 'Lavatory 1.5" Trap', multiplier: 1 },
	{ id: "shower_group_head", label: "Shower Group / Head", multiplier: 3 },
	{ id: "shower_stall", label: "Shower Stall", multiplier: 2 },
	{ id: "sink_flush_valve", label: "Sink Flush Valve", multiplier: 3 },
	{ id: "sink_scullery", label: "Sink Scullery", multiplier: 4 },
	{ id: "sink_service", label: "Sink Service", multiplier: 3 },
	{ id: "sink_surgeons", label: "Sink Surgeon's", multiplier: 3 },
	{ id: "swim_pool", label: "Swim Pool / 1000 gal", multiplier: 1 },
	{ id: "urinal_flush_valve", label: "Urinal Flush Valve", multiplier: 4 },
	{ id: "water_softener", label: "Water Softener", multiplier: 4 },
	{ id: "wc_flush_tank", label: "WC (flush tank)", multiplier: 3 },
	{ id: "wc_flush_valve", label: "WC (flush valve)", multiplier: 3 },
];

export const ORIFICE_FRACTION_OPTIONS = [
	{ value: "3/32", label: "3/32" },
	{ value: "1/8", label: "1/8" },
	{ value: "5/32", label: "5/32" },
	{ value: "3/16", label: "3/16" },
	{ value: "7/32", label: "7/32" },
	{ value: "1/4", label: "1/4" },
];

export const PIPE_DIAMETERS = [
	"1.25",
	"1.5",
	"2",
	"2.5",
	"3",
	"4"
];

export const SEPTIC_GPM_TABLE: Record<string, number> = {
	"1.25": 9,
	"1.5": 12,
	"2": 21,
	"2.5": 30,
	"3": 46,
	"4": 46,
};

export function createDefaultGpmData(): GpmData {
	const fixtureUnits = SEWAGE_FIXTURE_UNITS.reduce<Record<string, string>>(
		(acc, fixture) => {
			acc[fixture.id] = "0";
			return acc;
		},
		{},
	);

	return {
		mode: "known",
		knownGpm: "",
		calculatedGpm: "",
		sump: {
			drainageType: "",
			areaMode: "dimensions",
			length: "",
			width: "",
			areaSqft: "",
			zipCode: "",
			rainfall: "",
			lat: "",
			lon: "",
			manualRainfall: false,
		},
		septic: {
			systemType: "",
			distalPressure: "",
			totalLaterals: "",
			orificesPerLateral: "",
			orificeFraction: "",
			pipeDiameter: "",
		},
		sewage: {
			fixtureUnits,
			totalFixtureUnits: 0,
		},
	};
}
